/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Button,
  useUnselectAll,
  useNotify,
  useRefresh,
  useGetList,
  useRedirect,
} from "react-admin";
import MailIcon from "@mui/icons-material/Mail";
import IconSave from "@mui/icons-material/Save";
import IconCancel from "@mui/icons-material/Cancel";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import { callApi } from "../../dataprovider/miscApis";

function ConfirmButton({ selectedIds }) {
  const [showDialog, setShowDialog] = useState(false);
  const [sendingConfirmation, setSendingConfirmation] = useState(false);
  const [template, setTemplate] = useState("");
  const [templates, setTemplates] = useState([]);
  const [mailer, setMailer] = useState("");
  const [mailers, setMailers] = useState([]);
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const unselectAll = useUnselectAll();

  const { data: templateData, isLoading: templatesLoading } = useGetList(
    "eventMailTemplates",
    {
      pagination: { page: 1, perPage: 999 },
      sort: { field: "createdAt", order: "DESC" },
      filter: {
        isActive: 1,
      },
    },
    {
      enabled: showDialog,
    }
  );

  const { data: mailerData, isLoading: mailersLoading } = useGetList(
    "eventMailInfo",
    {
      pagination: { page: 1, perPage: 999 },
      sort: { field: "createdAt", order: "DESC" },
      filter: {
        type: "CONFIRMATION",
      },
    },
    {
      enabled: showDialog,
    }
  );

  const loading = templatesLoading || mailersLoading;

  const handleClick = () => {
    setShowDialog(true);
  };
  const handleCloseClick = () => {
    setShowDialog(false);
  };
  const onClickSendConfirmation = async () => {
    setSendingConfirmation(true);
    return callApi(
      "registrations/send-confirmation-mail",
      {
        ids: selectedIds,
        confirmationSent: dayjs(),
        templateId: template,
        mailInfoId: mailer,
      },
      "POST"
    )
      .then(() => {
        notify("Confirmation Sent Successfully");
        setShowDialog(false);
        unselectAll();
        refresh();
      })
      .catch(() => {
        notify("Email not configured", { type: "warning" });
      })
      .finally(() => {
        setSendingConfirmation(false);
      });
  };

  useEffect(() => {
    if (templateData?.length > 0) {
      setTemplates(templateData);
    }
  }, [templateData]);

  useEffect(() => {
    if (mailerData?.length > 0) {
      setMailers(mailerData);
      if (!mailer) {
        setMailer(mailerData[0].id);
      }
    }
  }, [mailerData]);

  const mailerLabel = (o) => `${o.fromName} <${o.fromEmail}>`;

  return (
    <>
      <Button onClick={handleClick} label="Send Confirmation" disabled={sendingConfirmation}>
        <MailIcon />
      </Button>
      <Dialog fullWidth open={showDialog} onClose={handleCloseClick} aria-label="Send email">
        <DialogTitle>Send email campaign</DialogTitle>
        <DialogContent>
          {!loading && mailers.length === 0 ? (
            <DialogContentText>No Mailers Available</DialogContentText>
          ) : null}
          {!loading && templates.length === 0 ? (
            <DialogContentText>No Templates Available</DialogContentText>
          ) : null}
          <Stack spacing={2} sx={{ mt: 1 }}>
            {mailers.length > 0 ? (
              <FormControl variant="filled" fullWidth>
                <InputLabel id="mailer-label">Mailer</InputLabel>
                <Select
                  labelId="mailer-label"
                  value={mailer}
                  onChange={(e) => setMailer(e.target.value)}
                  inputProps={{
                    name: "mailer",
                    id: "mailer",
                  }}
                >
                  {mailers.map((o) => (
                    <MenuItem key={o.id} value={o.id}>
                      {mailerLabel(o)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : null}
            {templates.length > 0 ? (
              <FormControl variant="filled" fullWidth>
                <InputLabel id="template-label">Template</InputLabel>
                <Select
                  labelId="template-label"
                  value={template}
                  onChange={(e) => setTemplate(e.target.value)}
                  inputProps={{
                    name: "template",
                    id: "template",
                  }}
                >
                  {templates.map((o) => (
                    <MenuItem key={o.id} value={o.id}>
                      {o.templateName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : null}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            label="ra.action.cancel"
            onClick={handleCloseClick}
            disabled={sendingConfirmation}
            sx={{ margin: "20px" }}
          >
            <IconCancel />
          </Button>
          {!loading && mailers.length === 0 ? (
            <Button
              label="Create Mailer"
              onClick={() => {
                redirect("/eventMailInfo");
              }}
              variant="contained"
              sx={{ margin: "20px" }}
            >
              <IconSave />
            </Button>
          ) : null}
          {!loading && templates.length === 0 ? (
            <Button
              label="Create Template"
              onClick={() => {
                redirect("/eventMailTemplates");
              }}
              variant="contained"
              sx={{ margin: "20px" }}
            >
              <IconSave />
            </Button>
          ) : (
            <Button
              label="ra.action.confirm"
              onClick={onClickSendConfirmation}
              variant="contained"
              disabled={!template || !mailer || sendingConfirmation}
              sx={{ margin: "20px" }}
            >
              {sendingConfirmation ? <CircularProgress color="inherit" size={20} /> : <IconSave />}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ConfirmButton;
